<template>
    <div class="pfs-curveplot-container">
      <pfs-curveplot 
      :studySelected="studySelected"/>
    </div>
  </template>
  
  <script>
  import PfsCurveplot from './PfsCurveplot.vue'
  
  export default {
      components: { PfsCurveplot },
  
      name: "pfs-curveplot-container",
  
      props: ['view', 'studySelected'],
  
      data: () => ({
      }),
      
      computed: {
        // normalTracks() {
        //   return Object.fromEntries(Object.entries(this.trackData).filter(([track, data]) => {
        //     return data.tissue === 'normal'
        //   }))
        // },
        // tumorTracks() {
        //   return Object.fromEntries(Object.entries(this.trackData).filter(([track, data]) => {
        //     return data.tissue === 'tumor'
        //   }))
        // },
        // combinedTracks() {},
      },
  
      mounted() {
      },
    }
  </script>
  
  <style>
  .pfs-curveplot-container {
      width: 100%;
      /* height: 200%; */
      aspect-ratio: 1;
      min-width: 600px;
      display: flex;
      flex-direction: column;
      /* margin: 10px; */
      /* padding-left: 10px; */
      overflow: scroll;
      /* height: 100%; */
  }
  </style>